{
  "groups": {
    "referenceNumber": "Número de Referência",
    "appointmentStartTimes": "Horários de Início de Agendamentos",
    "appointmentNotifications": "Notificações de Agendamento",
    "appointmentStatuses": "Status dos Agendamentos",
    "customAppointmentsGrid": "Grade Personalizada de Agendamentos",
    "limiter": "Limitador",
    "schedulingPortal": "Portal de Agendamento",
    "dockSelection": "Seleção de Doca",
    "timeDisplay": "Exibição de Horário",
    "gateManagement": "Gerenciamento de Portão",
    "smartGate": "SmartGate",
    "idValidation": "Validação de ID",
    "appointmentValidation": "Validação de Agendamento",
    "other": "Outro",
    "handlingUnits": "Unidades de Manuseio"
  },
  "groupDescriptions": {
    "referenceNumberIsTheReferenceYouCanRequestFromCarriersWhenTheyreSchedulingAnAppointment": "O número de referência é a identificação que você pode solicitar dos transportadores ao agendarem um compromisso.",
    "determineTheTimeIntervalsAtWhichAppointmentsWillBeAllowedToStart": "Determine os intervalos de tempo nos quais os agendamentos poderão ser iniciados.",
    "manageAllTypesOfAppointmentNotificationsForThisEntity": "Gerencie todos os tipos de notificações de agendamentos para esta {entity}.",
    "manageTheSchedulingPortalSettingsForThisEntity": "Gerencie as configurações do portal de agendamento para esta {entity}.",
    "handlingUnitsIsANumericFieldForRequestingUnitsEGPalletsDuringAppointmentSchedulingAddItToYourFormToAlsoEnableTheLimiterFeature": "Unidades de Manuseio é um campo numérico para solicitar unidades (ex.: paletes) durante o agendamento. Adicione-o ao seu formulário para também ativar o recurso de Limitador.",
    "theLimiterAllowsYouToSetAMaximumNumberOfAppointmentsOrHandlingUnitsEGPalletsThatCanBeScheduledPerDay": "O Limitador permite definir um número máximo de agendamentos ou unidades de manuseio (ex.: paletes) que podem ser agendados por dia."
  },
  "labels": {
    "minimumAmountOfReferenceNumbers": "Quantidade Mínima de Números de Referência",
    "maximumAmountOfReferenceNumbers": "Quantidade Máxima de Números de Referência",
    "includeReferenceNumberFieldOnAllAppointmentForms": "Incluir campo de número de referência em todos os formulários de agendamento?",
    "referenceNumberFieldName": "Nome do Campo de Número de Referência",
    "referenceNumberHelperText": "Texto de Ajuda do Número de Referência",
    "makeReferenceNumberARequiredField": "Tornar o número de referência obrigatório?",
    "allowAppointmentsForThisEntityToStartAt": "Permitir que agendamentos para esta {entity} comecem às:",
    "enableAppointmentNotificationsForThisEntity": "Ativar notificações de agendamento para esta {entity}?",
    "selectEachDesiredStartTimeIndividually": "Selecionar cada horário de início desejado individualmente",
    "hideTheLoadTypeDuration": "Ocultar duração do tipo de carga?",
    "uploadYourEntityLogoToDisplayItInTheSchedulingPortalAndInAllEmailNotifications": "Envie o logotipo da sua {entity} para exibi-lo no portal de agendamento e em todos os e-mails",
    "uploadYourWarehouseYardMapToDisplayItInTheSchedulingPortal": "Envie o mapa do pátio do armazém para exibição no portal de agendamento",
    "statusForNewlyCreatedAppointments": "Status para agendamentos recém-criados",
    "muteAppointmentNotifications": "Silenciar Notificações de Agendamento",
    "allowDockSelectionInSchedulingPortal": "Permitir seleção de doca no portal de agendamento?",
    "theStatusThatFollowsArrivedIs": "O status que segue \"Chegou\" é",
    "displayTimeIn": "Exibir horário em:",
    "customizeAppointmentDetails": "Personalizar detalhes do agendamento",
    "gridTileConfig": "Configuração dos blocos da grade",
    "enforceCheckInGeofencingToRequireDriversToProvideTheirRealTimeLocation": "Exigir geofencing para que os motoristas forneçam sua localização em tempo real",
    "wouldYouLikeToShowAdditionalInformationToTheDriversAfterTheyCheckInOptional": "Deseja mostrar informações adicionais aos motoristas após o check-in? (opcional)",
    "preventReschedulingAppointmentsInTheSchedulingPortal": "Impedir reagendamento de compromissos no portal de agendamento?",
    "revertToRequestedOnCarrierReschedule": "Reverter para Solicitado ao reagendar pela transportadora",
    "observationMatchAttribute": "Atributo de Correspondência de Observação",
    "observationMatchTimeWindow": "Janela de Tempo para Correspondência de Observação",
    "autoDepartAssets": "Realizar saídas automáticas de ativos",
    "autoCreateAssets": "Criar ativos automaticamente",
    "gateFeedColumns": "Colunas do Gate Feed",
    "checkInEarlyThreshold": "Limite de Antecedência para Check-in",
    "checkInLateThreshold": "Limite de Atraso para Check-in",
    "technicalContactEmailAddress": "Endereço de E-mail do Contato Técnico",
    "technicalContactEmailThrottleMinutes": "Minutos de Retardo para Contato Técnico",
    "requireUniqueReferenceNumbers": "Exigir Números de Referência Únicos",
    "appointmentStartTimeInterval": "Intervalo de Início do Agendamento",
    "referenceNumberInputMode": "Modo de Entrada do Número de Referência",
    "uploadWarehouseYardMap": "Envie o mapa do pátio do armazém para exibição no portal de agendamento",
    "includeHandlingUnitsFieldOnAllAppointmentForms": "Incluir campo de unidades de manuseio em todos os formulários de agendamento?",
    "handlingUnitsLabel": "Rótulo de Unidades de Manuseio",
    "handlingUnitsHelperText": "Texto de Ajuda de Unidades de Manuseio",
    "makeHandlingUnitsARequiredField": "Tornar as unidades de manuseio obrigatórias?",
    "maximumHandlingUnitsValueForAnAppointment": "Valor máximo de Unidades de Manuseio para um agendamento",
    "minimumHandlingUnitsValueForAnAppointment": "Valor mínimo de Unidades de Manuseio para um agendamento",
    "checkOutBolSignedRequired": "Assinatura de BOL obrigatória na saída",
    "requireBolPrinting": "Exigir impressão do BOL",
    "checkOutBolNotLoadingErrorMessage": "Mensagem de erro quando o BOL falha ao carregar no checkout",
    "checkOutIdentifier": "Identificador de saída",
    "enableCheckInIdValidationPersona": "Ativar validação de ID no check-in (Persona)",
    "requireCheckInIdValidationToCompleteCheckIn": "Exigir validação de ID para concluir o check-in",
    "checkInIdValidationTemplate": "Modelo de validação de ID no check-in",
    "geofenceRadius": "Raio do geofencing",
    "geofenceRadiusUnit": "Unidade do raio da cerca geográfica",
    "createAppointmentOnExternalValidationFailure": "Criar agendamento mesmo com falha na validação externa",
    "enableOverrideLimiterFunction": "Ativar função de sobrescrição do limitador",
    "receiveUnplannedCheckInEmailNotifications": "Receber notificações por e-mail de check-in não planejado",
    "driversMustEnterAReferenceNumberToCheckIn": "Os motoristas devem inserir um número de referência para fazer o check-in",
    "driversCanOnlyCheckInIfTheReferenceNumberMatchesTheScheduledAppointment": "Os motoristas só podem fazer check-in se o número de referência corresponder ao agendamento",
    "driversSkipTheReferenceNumberStepDuringCheckIn": "Os motoristas pulam a etapa do número de referência durante o check-in",
    "customizeTheFirstSmsMessageDriversReceiveAfterCheckInOptional": "Personalize a primeira mensagem SMS que os motoristas recebem após o check-in (opcional)",
    "includeYardMapImageInTheFirstCheckInSms": "Incluir a imagem do Mapa do Pátio no primeiro SMS de check-in?",
    "automaticallyDeleteStoredIdValidations": "Excluir automaticamente as validações de ID armazenadas",
    "deleteStoredIdValidationsAfter": "Excluir as validações de ID armazenadas após",
    "displayDatesAs": "Exibir datas como:",
    "displayTimeAs": "Exibir horário como:"
  },
  "descriptions": {
    "requireAtLeastThisAmountOfReferenceNumbersForAnAppointment": "Exigir pelo menos esta quantidade de números de referência para um agendamento",
    "requireAtMostThisAmountOfReferenceNumbersForAnAppointment": "Exigir no máximo esta quantidade de números de referência para um agendamento",
    "theDisplayNameForTheReferenceNumberFieldEgPoNumberShipmentId": "O nome exibido para o campo de número de referência. Ex: \"Número do Pedido\", \"ID do Envio\"",
    "additionalInformationToHelpFillInTheReferenceNumberFieldEgReferenceNumberShouldStartWithOdXx": "Informações adicionais para preencher o campo de número de referência. Ex: \"O número de referência deve começar com OD-XX\"",
    "requireTheReferenceNumberForAllAppointmentsBeingScheduled": "Exigir o número de referência para todos os agendamentos",
    "thisOnlyAffectsNewlyCreatedAppointments": "Isso afeta apenas os agendamentos recém-criados",
    "theDurationIsDisplayedOnTheLoadTypesSelectListBookingAnAppointmentInTheSchedulingPortal": "A duração é exibida na lista de tipos de carga ao agendar no portal",
    "allowDockSelectionWhenBookingAnAppointmentInTheSchedulingPortal": "Permitir seleção de doca ao agendar no portal",
    "thisSettingWillAllowTheChoiceOfAnAlternateInProgressStatusBetweenArrivedAndCompleted": "Esta configuração permite a escolha de um status \"Em andamento\" alternativo entre \"Chegado\" e \"Concluído\"",
    "determineHowTimeWillBeDisplayedAcrossThePlatformForAllUsersOfThisOrgIncludingTheAppointmentsGridAndReports": "Determina como o horário será exibido na plataforma para todos os usuários desta organização, incluindo a grade de agendamentos e relatórios",
    "enableToSwitchToTheNewCustomizableAppointmentDetailsSystem": "Habilitar o novo sistema personalizável de detalhes do agendamento",
    "userConfigurationOfHowGridTilesWillBeDisplayed": "Configuração do usuário sobre como os blocos da grade serão exibidos",
    "thisSettingAsksForTheDriversLocationAndRestrictsThemFromCheckingInWhenTheyAreMoreThanOneMileAwayFromYourWarehouse": "Esta configuração solicita a localização do motorista e o impede de fazer check-in se estiver a mais de uma milha do seu armazém",
    "preventCarriersFromReschedulingAppointmentsOptional": "Impedir transportadoras de reagendar compromissos. (opcional)",
    "whenACarrierReschedulesAScheduledAppointmentMoveItBackToRequestedForReApproval": "Quando uma transportadora reagenda um compromisso Agendado, devolvê-lo para Solicitado para nova aprovação",
    "attributeToBeUsedForMatchingObservations": "Atributo a ser usado para corresponder observações",
    "theNumberOfMinutesToAccountForAnObservationBeforeAndAfterTheCheckInTime": "Número de minutos a considerar para uma observação antes e depois do horário de check-in",
    "theNumberOfMinutesBeforeTheAppointmentStartTimeThatACarrierCanCheckIn": "Número de minutos antes do horário de início do agendamento em que uma transportadora pode fazer check-in",
    "theNumberOfMinutesAfterTheAppointmentStartTimeThatACarrierCanCheckIn": "Número de minutos após o horário de início do agendamento em que uma transportadora pode fazer check-in",
    "emailAddressWhereTechnicalIssuesAndInformationWillBeSent": "Endereço de e-mail para onde serão enviados problemas técnicos e informações",
    "theTimeBetweenNotificationsSentToTheTechnicalContactWhenAValidationServerErrorOccurs": "Tempo entre notificações enviadas ao contato técnico quando ocorre um erro de validação do servidor",
    "aListOfMutedAppointmentNotifications": "Uma lista de notificações de agendamento silenciadas",
    "requireUniqueReferenceNumbersForAllAppointmentsBeingScheduled": "Exigir números de referência únicos para todos os agendamentos",
    "thisIsTheIntervalMinutesBetweenWhenAppointmentsCanStart": "Este é o intervalo em minutos entre os horários possíveis de início dos agendamentos",
    "enableTheCustomAppointmentStartTimesSetting": "Ativar a configuração de horários personalizados de início de agendamento",
    "theInputModeForTheReferenceNumberField": "Modo de entrada para o campo de número de referência",
    "theDisplayNameForTheHandlingUnitsFieldEgPalletsCases": "Nome de exibição para o campo de unidades de manuseio. Ex.: Paletes, Caixas",
    "theDisplayNameForTheUnitTypeFieldEgPalletCountSkidCount": "Nome de exibição para o campo de tipo de unidade. Ex.: Contagem de paletes, Contagem de skids",
    "requireTheUnitTypeFieldForAllAppointmentsBeingScheduled": "Exigir o campo de tipo de unidade para todos os agendamentos",
    "autoDepartAssetsOnReceivingOutgateEvent": "Realiza saída automaticamente de um ativo ao receber o evento de saída do mesmo",
    "autoCreateAssetsOnReceivingIngateEvent": "Cria automaticamente um ativo ao receber o evento de entrada do mesmo",
    "columnsAvailableOnTheAiGateFeedPageRequiredColumnsAreAlwaysShown": "Colunas disponíveis na página AI Gate Feed. Colunas obrigatórias são sempre exibidas.",
    "createAppointmentsEvenIfAppointmentValidationDoesNotPass": "Criar agendamentos mesmo que a validação do agendamento não seja aprovada",
    "theRadiusInMilesThatTheDriverMustBeWithinToCheckInThisIsOnlyApplicableIfGeofencingIsEnabled": "O raio em milhas dentro do qual o motorista deve estar para fazer o check-in. Isso só se aplica se o geofencing estiver habilitado.",
    "theDistanceUnitTheGeofenceRadiusIsMeasuredIn": "A unidade de distância em que o raio da cerca geográfica é medido.",
    "additionalInformationToHelpFillInTheUnitTypeFieldEgUnitTypeShouldBeOnlyNumbers": "Informações adicionais para ajudar a preencher o campo de tipo de unidade. Ex.: O tipo de unidade deve conter apenas números",
    "whenTheLimiterIs100ReachedThisFeatureAllowsOnlyWarehouseUsersToOverrideAndCreateOrApproveAppointmentsAndUnits": "Quando o limitador atinge 100%, esta função permite que apenas os usuários do armazém substituam e criem ou aprovem agendamentos e unidades",
    "setsTheMaximumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "Define o valor numérico máximo que pode ser inserido no campo de Unidades de Manuseio em um agendamento",
    "setsTheMinimumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "Define o valor numérico mínimo que pode ser inserido no campo de Unidades de Manuseio em um agendamento",
    "theAssetAttributeTheSystemWillUseToValidateTheCheckOutForm": "O atributo do ativo que o sistema usará para validar o formulário de saída",
    "enforceBolSigningOnCheckOutForm": "Exigir assinatura do BOL no formulário de saída",
    "driverMustPrintTheBolToCompleteTheCheckoutWithAPhysicalSignature": "O motorista deve imprimir o BOL para concluir a saída com uma assinatura física.",
    "errorMessageShownToDriversWhenTheBolFailsToLoadDuringCheckOut": "Se o BOL não estiver disponível, o transportador não poderá assiná-lo, o que bloqueará o checkout. Aqui você pode definir instruções personalizadas que o motorista verá caso isso aconteça.",
    "showThePersonaComponentInTheCheckInFlowForIdentityVerification": "Exibir o componente Persona no fluxo de check-in para verificação de identidade",
    "requireSuccessfulPersonaValidationBeforeTheDriverCanCompleteCheckIn": "Exigir validação Persona bem-sucedida antes que o motorista possa concluir o check-in",
    "personaTemplateUsedForCheckInIdentityVerification": "Modelo Persona usado para verificação de identidade no check-in",
    "warehouseSubscribersReceiveEmailNotificationsWhenAnUnplannedCheckInOccurs": "Os assinantes do armazém recebem notificações por e-mail quando ocorre um check-in não planejado",
    "thisMessageReplacesTheDefaultCheckInConfirmationTextSentToTheDriverBySmsLeaveBlankToUseTheDefaultMessage": "Esta mensagem substitui o texto de confirmação de check-in padrão enviado ao motorista por SMS. Deixe em branco para usar a mensagem padrão.",
    "sendsYourYardMapAsASeparateImageMessageRightAfterTheCheckInSmsRequiresAYardMapToBeUploadedForThisWarehouse": "Envia o Mapa do Pátio como uma mensagem de imagem separada logo após o SMS de check-in. Requer que um Mapa do Pátio tenha sido enviado para este armazém.",
    "storedIdValidationRecordsArePermanentlyDeletedOnceTheRetentionPeriodHasPassed": "Os registros de validação de ID armazenados são excluídos permanentemente após o período de retenção",
    "numberOfDaysAStoredIdValidationIsKeptBeforeItIsDeleted": "Número de dias que uma validação de ID armazenada é mantida antes de ser excluída",
    "determineHowDatesWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "Determine como as datas serão exibidas para os usuários desta empresa em todas as experiências voltadas à empresa.",
    "determineHowTimeWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "Determine como o horário será exibido para os usuários desta empresa em todas as experiências voltadas à empresa."
  },
  "placeholders": {
    "referenceNumberAssociatedWithAppointment": "Número de referência associado ao agendamento",
    "insertMessageHere": "Insira a mensagem aqui"
  },
  "dropdownOptions": {
    "allowAppointmentsForThisEntityToStartAt": {
      "topOfTheHour00": "Na hora cheia (:00)",
      "topAndBottomOfTheHour00And30": "Na hora cheia e na meia hora (:00 e :30)",
      "everyTwentyMinutes0020And40": "A cada vinte minutos (:00, :20 e :40)",
      "everyQuarterOfTheHour001530And45": "A cada quinze minutos (:00, :15, :30 e :45)",
      "customStartTimes": "Horários personalizados"
    },
    "appointmentStartTimeInterval": {
      "15Minutes": "15 minutos",
      "30Minutes": "30 minutos",
      "60Minutes": "60 minutos",
      "90Minutes": "90 minutos"
    },
    "observationMatchAttribute": {
      "licensePlate": "Placa do veículo",
      "dotNumber": "Número DOT",
      "any": "Qualquer um",
      "cascade": "Cascata"
    },
    "referenceNumberInputMode": {
      "alphanumeric": "Alfanumérico",
      "numeric": "Numérico"
    },
    "statusForNewlyCreatedAppointments": {
      "scheduled": "Agendado",
      "requested": "Solicitado"
    },
    "theStatusThatFollowsArrivedIs": {
      "inProgress": "Em andamento",
      "completed": "Concluído"
    },
    "includeReferenceNumberFieldOnAllAppointmentForms": {
      "noDontIncludeTheReferenceNumberField": "Não, não incluir o campo de número de referência",
      "yesIncludeTheReferenceNumberField": "Sim, incluir o campo de número de referência"
    },
    "hideTheLoadTypeDuration": {
      "noDontHideTheLoadTypeDuration": "Não, não ocultar a duração do tipo de carga",
      "yesHideTheLoadTypeDuration": "Sim, ocultar a duração do tipo de carga"
    },
    "enableAppointmentNotificationsForThisEntity": {
      "noDisableAppointmentNotifications": "Não, desativar notificações de agendamento",
      "yesEnableAppointmentNotifications": "Sim, ativar notificações de agendamento"
    },
    "allowDockSelectionInSchedulingPortal": {
      "noDontAllowDockSelection": "Não, não permitir seleção de doca",
      "yesAllowTheDockSelection": "Sim, permitir seleção de doca"
    },
    "displayTimeIn": {
      "regularTime12Hour": "Horário comum (12 horas)",
      "militaryTime24Hour": "Horário militar (24 horas)"
    },
    "preventReschedulingAppointmentsInTheSchedulingPortal": {
      "allowReschedulingInTheSchedulingPortal": "Permitir reagendamento no portal",
      "preventReschedulingInTheSchedulingPortal": "Impedir reagendamento no portal"
    },
    "revertToRequestedOnCarrierReschedule": {
      "revertToRequestedOnCarrierReschedule": "Reverter para Solicitado ao reagendar pela transportadora",
      "keepStatusUnchangedOnCarrierReschedule": "Manter o status inalterado ao reagendar pela transportadora"
    },
    "makeReferenceNumberARequiredField": {
      "noDontMakeReferenceNumberARequiredField": "Não, não tornar o número de referência obrigatório",
      "yesMakeReferenceNumberARequiredField": "Sim, tornar o número de referência obrigatório"
    },
    "requireUniqueReferenceNumbers": {
      "noDontRequireUniqueReferenceNumbers": "Não, não exigir números de referência exclusivos",
      "yesRequireUniqueReferenceNumbers": "Sim, exigir números de referência exclusivos"
    },
    "makeHandlingUnitsARequiredField": {
      "noDontMakeHandlingUnitsARequiredField": "Não, não tornar as unidades de manuseio obrigatórias",
      "yesMakeHandlingUnitsARequiredField": "Sim, tornar as unidades de manuseio obrigatórias"
    },
    "includeHandlingUnitsFieldOnAllAppointmentForms": {
      "noDontIncludeTheHandlingUnitsField": "Não, não incluir o campo de unidades de manuseio",
      "yesIncludeTheHandlingUnitsField": "Sim, incluir o campo de unidades de manuseio"
    },
    "checkOutIdentifier": {
      "licensePlate": "Placa do veículo",
      "phoneNumber": "Número de telefone",
      "any": "Qualquer um"
    },
    "geofenceRadiusUnit": {
      "miles": "Milhas",
      "kilometers": "Quilômetros"
    },
    "enableCheckInIdValidationPersona": {
      "no": "Não",
      "yes": "Sim"
    },
    "requireCheckInIdValidationToCompleteCheckIn": {
      "no": "Não",
      "yes": "Sim"
    },
    "checkInIdValidationTemplate": {
      "driverLicenseFront1Retry": "Carteira de motorista - Frente - 1 nova tentativa",
      "driverLicenseFrontBarcodeFaceUsOnly1Retry": "Carteira de motorista - Frente, código de barras, rosto, apenas EUA, 1 nova tentativa"
    },
    "receiveUnplannedCheckInEmailNotifications": {
      "no": "Não",
      "yes": "Sim"
    },
    "displayDatesAs": {
      "mmDdYyyy": "MM/DD/AAAA",
      "ddMmYyyy": "DD/MM/AAAA",
      "yyyyMmDd": "AAAA-MM-DD",
      "tueMmDdYyyy": "Ter, MM/DD/AAAA",
      "tueDdMmYyyy": "Ter, DD/MM/AAAA",
      "tueYyyyMmDd": "Ter, AAAA-MM-DD"
    },
    "displayTimeAs": {
      "12HourEG700Am": "12 horas (ex.: 7:00 AM)",
      "24HourEG0700": "24 horas (ex.: 07:00)"
    }
  },
  "examples": {
    "displayTimeIn": {
      "eG700Am700Pm": "Ex.: 7:00 AM / 7:00 PM",
      "eG07001900": "Ex.: 07:00 / 19:00"
    }
  },
  "notes": {
    "notesPrefix": "Observação:",
    "ifLeftEmptyTheDefaultNameWillBeApplied": "Se deixado em branco, o nome padrão será aplicado",
    "ifLeftEmptyTheDefaultHelperTextWillBeApplied": "Se deixado em branco, o texto de ajuda padrão será aplicado",
    "enablingThisOptionDoesNotImpactNotificationsThatAreAlreadyDisabledOnTheAppointmentLevelIndividually": "Ativar esta opção não afeta as notificações que já estão desativadas individualmente no nível do agendamento.",
    "ifLeftEmptyNoNotificationsWillBeSent": "Se deixado em branco, nenhuma notificação será enviada",
    "referenceNumbersAssignedToCancelledOrNoShowAppointmentsMayBeReusedOnNewAppointments": "Os números de referência atribuídos a compromissos cancelados ou não comparecidos podem ser reutilizados em novos compromissos",
    "ifEmptyTheDefaultNameWillBeApplied": "Se estiver vazio, o nome padrão será aplicado"
  },
  "links": {},
  "sectionLabels": {
    "drivers": "Motoristas",
    "checkInSms": "SMS de check-in",
    "dataRetention": "Retenção de dados"
  }
}
